// 탭한 자리에 잠깐 퍼지며 사라지는 링.
import * as THREE from 'three';

export interface TapMarker {
  mesh: THREE.Mesh;
  show(x: number, z: number): void;
  update(dt: number): void;
}

export function createTapMarker(parent: THREE.Object3D): TapMarker {
  const mat = new THREE.MeshBasicMaterial({ color: 0x1F2E2B, transparent: true, opacity: 0, depthWrite: false });
  const mesh = new THREE.Mesh(new THREE.RingGeometry(0.35, 0.47, 32), mat);
  mesh.rotation.x = -Math.PI / 2;
  parent.add(mesh);
  let t = -1;
  return {
    mesh,
    show(x, z) { mesh.position.set(x, 0.03, z); t = 0; },
    update(dt) {
      if (t < 0) return;
      t += dt;
      const q = t / 1.2;
      if (q >= 1) { mat.opacity = 0; t = -1; }
      else { mat.opacity = 0.55 * (1 - q); mesh.scale.setScalar(1 + q * 0.6); }
    },
  };
}
